
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { BaggingDataDetail, SttResult } from "@/domain/entities/Bagging";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import PreviewImagePod from "../../../shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";

class Props {
  detailData = prop<BaggingDataDetail>({
    type: Object,
    required: true
  });
}
@Options({
  components: {
    Title,
    PreviewImagePod
  }
})
export default class DetailBaggingSection extends Vue.with(Props) {
  formatWeight(n: number): string {
    return formatByCountry(n, { type: "weight", suffix: " kg" });
  }

  formatQuantity(n: number): string {
    return formatByCountry(n, { type: "quantity" });
  }

  get totalVolumeWeight() {
    const weightVolumeStt = this.detailData.sttResult.reduce((sum: any, item: any) => sum + item.sttVolumeWeight, 0);
    return weightVolumeStt;
  }
  get columns() {
    const column = [
      {
        name: "No.",
        styleHead: "w-10 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult, index: number) => {
          return `<div class="text-black-lp-300">${index + 1}</div>`;
        }
      },
      {
        name: `No. STT`,
        styleHead: "w-48 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${item.sttNo}</div>`;
        }
      },
      {
        name: this.$t("No. Referensi"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300 break-all">${item.sttNoRefExternal ||
            "-"}</div>`;
        }
      },
      {
        name: "Chargeable weight",
        styleHead: "w-32 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttChargeableWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.grossWeight"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttGrossWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.volumeWeight"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttVolumeWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.koli"),
        styleHead: " w-20 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${item.sttTotalPiece}</div>`;
        }
      },
      {
        name: this.$t("Komoditas"),
        styleHead: "w-68 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300 break-all">${item.sttCommodityName}</div>`;
        }
      },
      {
        name: this.$t("bagging.destinationCity"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300 flex">
                  <div class="rounded px-2 py-0 bg-gray-lp-400">
                      ${item.sttDestinationCityId}
                  </div>
                </div>`;
        }
      },
      {
        name: this.$t("Dangerous goods"),
        styleHead: "w-36 text-left whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) =>
          `<div class="text-black-lp-300">
          ${item.isDangerousGoods ? this.$t("Ya") : this.$t("Tidak")}
            </div>`
      }
    ];

    if (!this.detailData.isPaid) {
      column.splice(2, 0, {
        name: this.$t("bagging.payment"),
        styleHead: "w-48 text-left text-black-lp-300 whitespace-no-wrap",
        styleCustom: "align-top",
        render: (item: SttResult) => {
          return `<div class='text-left ${
            item?.paymentStatus === "unpaid"
              ? "bg-yellow-lp-500"
              : "bg-green-lp-700"
          } text-white font-medium font-montserrat rounded-md px-3 py-1 whitespace-no-wrap text-12px xxl:text-14px'>${
            item?.paymentStatus === "unpaid"
              ? this.$t("Kurang Bayar")
              : this.$t("Sudah Lunas")
          }</div>`;
        }
      });
    }
    return column;
  }

  // photo proof
  isPreviewPhotoProof = false;
}
